import jQuery from 'jquery';
import 'slick-carousel';
import Stickyfill from 'stickyfilljs';
import Drift from 'drift-zoom';

// Make jQuery available globally
window.$ = window.jQuery = jQuery;
window.Stickyfill = Stickyfill;
window.Drift = Drift;